import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { nodeName } from "jquery";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import { getContractDeatil, getContractHistory } from "../Actions/ContractMgmtAPI";
import { MdReport } from "react-icons/md";

class ClientShipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      Showinfo: false
    };
  }
  renderview(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("ContractManagementContent.ContractDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    const { arraylist, currentPage, totalRecords, pageSize, t } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist.length != 0 ? (
          <Paginator
            first={currentPage ?? 0}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card mb-0">
                {t("CommonText.NoItem")}
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, t } = this.props;
    return arraylist &&
      arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card mb-2"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-sm-10 col-md-11 col-10 m-auto"}>
                    <div className="row">
                      <div className={"col-sm-12 mb-2"}>
                        <h6 onClick={() => {
                          this.props.history.push(`/Home/ServiceBudgetOverview/${item.contractId}/${item.shipId}`)
                        }} className="resource-list-title m-0">
                          {/* {item.shipName} */} {item.contractNumber}
                        </h6>
                      </div>

                      {/* <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>{t("ContractManagementContent.ClientName")} : </strong>
                          <span className="lato ">{item.clientName}</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>{t("ContractManagementContent.StartDate")} : </strong>
                          <span className="lato ">
                            {moment(item.startDate).format("DD MMM YYYY")}
                          </span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>{t("ContractManagementContent.ExpiryDate")} : </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato">{moment(item.endDate).format("DD MMM YYYY")}</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>{t("ContractManagementContent.ContractCopy")} : </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato">{item.attachmentName}</span>
                          {item.attachmentName ?
                            <i
                              className="fa fa-download ml-1 fa-lg click"
                              style={{ width: 20 }}
                              onClick={() => this.downloadContract(item.attachmentName,item.attachmentGuid)}
                            ></i>
                            : ""}
                        </span>{t("ShipManagementContent.BasicDetails")}
                      </div> */}
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>{t("ContractManagementContent.ShipName")}: </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato">{item.shipName}</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>{t("ContractManagementContent.ContractType")}: </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato">{item.contractTypeName}</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>{t("ContractManagementContent.PlanType")}:</strong>
                          <i aria-hidden="true"></i>
                          <span className="lato">{item.planName}</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"}>
                        <span>
                          <strong>{t("ContractManagementContent.Status")}: </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato text-capitalize">{item.contractStatus}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2 col-md-1 col-2 col-m-auto text-right">
                    {/* <MdReport
                      className="px-1 click"
                      style={{
                        color: "rgb(26, 52, 100)",
                        fontSize: "2.2rem",
                        marginTop: "-11px",
                      }}
                      onClick={() => this.gotobudgetScreen(item.contractId)}
                    /> */}
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={this.renderview()}
                    >
                      <i
                        className="fa fa-eye click pl-3"
                        aria-hidden="true"
                        onClick={() =>
                          this.ShowSidePanel(item.contractId)
                        }
                        style={{ color: " #1a3464", fontSize: '1.8rem', marginLeft: '-15px' }}
                      ></i>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
  downloadContract(Filename, Guid) {
    this.props.dispatch(DownloadAttachment(Filename, Guid));
  }
  ShowSidePanel = (id) => {
    this.props.dispatch({ type: "ShowContractDetailsPane", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/Contracts/${id}`);
    this.props.dispatch(getContractDeatil(id));
    this.props.dispatch(getContractHistory(id));
    window.scrollTo(0, 0);
  };
  // gotobudgetScreen = (id) => {
  //   this.props.history.push(`/Home/ServiceBudgetOverview/${id}`);
  // }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientShipCard)));
